import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ClearSeassion, SET_PREV_PATH } from '../../../constant/auth'
const initialState = {
  isLoading: false,
  isAuthenticated: false,
  user: {},
}
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    startLoading(state) {
      return {
        ...state,
        isLoading: true,
      }
    },
    doLogin(state, action) {
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      }
    },
    doLogout(state) {
      return {
        ...state,
        user: {},
        isAuthenticated: false,
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchLogout.fulfilled, (state, action) => {
      state.isAuthenticated = false
      state.user = {}
    })
    builder.addCase(fetchLogout.rejected, (state, action) => {
      state.isAuthenticated = false
      state.user = {}
    })
  },
})

export const fetchLogout = createAsyncThunk(
  'auth/logout',
  (disableAutoLogin) => {
    ClearSeassion()
    const path = window.location.pathname + window.location.search;
    SET_PREV_PATH(path)
    localStorage.setItem('version', process.env.REACT_APP_VERSION);
    return true
  }
)
export const authReducer = authSlice.reducer
export const { startLoading, doLogin, doLogout } = authSlice.actions
